import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { IntroSection } from './components/IntroSection';
import { LocationSection } from './components/LocationSection';
import { QualitiesSection } from './components/QualitiesSection';
import { AmenitiesSection } from './components/AmenitiesSection';
import { PhasesSection } from './components/PhasesSection';
import { AvailabilitySection } from './components/AvailabilitySection';
import { DeveloperSection } from './components/DeveloperSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
import { WhatsAppButton } from './components/ui/WhatsAppButton';
import { LanguageProvider } from './context/LanguageContext';
export function App() {
  return <LanguageProvider data-id="element-0">
      <div className="min-h-screen bg-white" data-id="element-1">
        <Navbar data-id="element-2" />
        <main data-id="element-3">
          <Hero data-id="element-4" />
          <IntroSection data-id="element-5" />
          <LocationSection data-id="element-6" />
          <QualitiesSection data-id="element-7" />
          <AmenitiesSection data-id="element-8" />
          <PhasesSection data-id="element-9" />
          <AvailabilitySection data-id="element-10" />
          <DeveloperSection data-id="element-11" />
          <ContactSection data-id="element-12" />
        </main>
        <Footer data-id="element-13" />
        <WhatsAppButton data-id="element-14" />
      </div>
    </LanguageProvider>;
}